/**
 * React directive registrations.
 *
 * Each React page/component is registered here as an Angular directive via
 * react2angular. Add new entries as pages are migrated.
 *
 * Pattern:
 *   import { MyPage } from '../../../src/pages/MyPage';
 *   // Wrap with withProviders if the page (or anything it renders) uses
 *   // TanStack Query, OpenFeature, or any other provider-backed feature.
 *   (window as any).frontendApp.directive('reactMyPage', react2angular(withProviders(MyPage)));
 *   // Otherwise (purely static / direct-fetch pages):
 *   (window as any).frontendApp.directive('reactMyPage', react2angular(MyPage));
 *
 * Then in frontend.ts:
 *   .when('/my-page', { template: '<react-my-page></react-my-page>' })
 */

import { react2angular } from '../../../src/utilities/react2angular';
import { withProviders } from '../../../src/utilities/withProviders';
import { SettingsPage } from '../../../src/pages/SettingsPage';
import { OrganizationPage } from '../../../src/pages/OrganizationPage';
import { NotFoundPage } from '../../../src/pages/NotFoundPage';
import { ProjectListPage } from '../../../src/pages/ProjectListPage';
import { GetStartedPage } from '../../../src/pages/GetStartedPage';
import { ResetPasswordPage } from '../../../src/pages/ResetPasswordPage';
import { ProjectAdminPage } from '../../../src/pages/ProjectAdminPage';
import { ProjectDetailPage } from '../../../src/pages/ProjectDetailPage';
import { CollectionPage } from '../../../src/pages/CollectionPage';
import { BrowsePage } from '../../../src/pages/BrowsePage';
import { BrowseBatchPage } from '../../../src/pages/BrowseBatchPage';
import { SearchResultsPage } from '../../../src/pages/SearchResultsPage';
import { SystemMessageBanner } from '../../../src/components/SystemMessageBanner';
import { WebSocketBridge } from '../../../src/components/WebSocketBridge';

(window as any).frontendApp.directive('reactSettingsPage', react2angular(SettingsPage));
(window as any).frontendApp.directive('reactOrganizationPage', react2angular(OrganizationPage));
(window as any).frontendApp.directive('reactNotFoundPage', react2angular(NotFoundPage));
(window as any).frontendApp.directive('reactProjectListPage', react2angular(withProviders(ProjectListPage)));
(window as any).frontendApp.directive('reactGetStartedPage', react2angular(withProviders(GetStartedPage)));
(window as any).frontendApp.directive('reactResetPasswordPage', react2angular(ResetPasswordPage));
(window as any).frontendApp.directive('reactProjectAdminPage', react2angular(withProviders(ProjectAdminPage)));
(window as any).frontendApp.directive('reactProjectDetailPage', react2angular(withProviders(ProjectDetailPage)));
(window as any).frontendApp.directive('reactCollectionPage', react2angular(withProviders(CollectionPage)));
(window as any).frontendApp.directive('reactBrowsePage', react2angular(withProviders(BrowsePage)));
(window as any).frontendApp.directive('reactBatchReviewPage', react2angular(withProviders(BrowseBatchPage)));
(window as any).frontendApp.directive('reactSearchResultsPage', react2angular(withProviders(SearchResultsPage)));
(window as any).frontendApp.directive('reactSystemMessageBanner', react2angular(SystemMessageBanner));
// Renders nothing; owns every app-wide websocket listener. Mounted in index.html so it
// lives for the whole session rather than for the lifetime of one route.
(window as any).frontendApp.directive('reactWebsocketBridge', react2angular(withProviders(WebSocketBridge)));
